if (!customElements.get("collection-paginate")) {
  customElements.define(
    "collection-paginate",
    class CollectionPaginate extends HTMLElement {
      constructor() {
        super();

        this.loadingIndicator = this.querySelector(".paginate--loading");
        this.filter = this.closest(".collection-grid-section").querySelector(
          "#main-collection-filters filter-dropdown"
        );
        this.productGrid = this.querySelector("#main-collection-product-grid");
        this.currentPage = parseInt(this.dataset.pageNum);
        this.totalPages = parseInt(this.dataset.pageTotal);
        this.inProgress = false;

        if (this.currentPage >= this.totalPages) this.removeLoader.bind(this);
        window.addEventListener("scroll", this.loaderInView.bind(this));
      }

      loaderInView() {
        const viewPosition = window.innerHeight - 50;
        if (this.loadingIndicator) {
          const indicatorBox = this.loadingIndicator.getBoundingClientRect();
          if (!this.inProgress && indicatorBox) {
            if (indicatorBox.bottom <= viewPosition) {
              this.inProgress = true;
              this.getNextContents();
            }
          }
        }
      }

      async getNextContents() {
        try {
          const response = await fetch(
            `${window.location.pathname}/${this.filter.activeFilters.join("+")}?page=${
              this.currentPage + 1
            }`
          );
          const data = await response.text();

          const paginateHTML = document.createElement("div");
          paginateHTML.innerHTML = data;
          const newCollectionPaginate = paginateHTML.querySelector("collection-paginate");

          if (this.productGrid && newCollectionPaginate) {
            this.productGrid.innerHTML += newCollectionPaginate.productGrid.innerHTML;
            // update currentpage index
            this.currentPage = newCollectionPaginate.currentPage;
            // remove loading indicator if all the pages have been loaded
            this.currentPage >= this.totalPages ? this.removeLoader() : "";

            // reinit stamped reviews
            stampedInit(window, document);

            // end of paginate operation
            this.inProgress = false;
          }

          function addSlickCarousel() {
            if (typeof jQuery === "function") {
              let productWraps = document.querySelectorAll(
                ".product-grid .grid__item:not(.carouselAdded)"
              ); // get product cards

              if (
                !productWraps.length ||
                typeof jQuery !== "function" ||
                typeof $().slick === "undefined"
              )
                return;

              productWraps.forEach(function (productWrap, index) {
                let pdpLink = productWrap.querySelector(".card-wrapper > a"); // get PDP links
                let request = jQuery.getJSON(`${pdpLink.href}.json`); // request the product's JSON
                productWrap.classList.add(`carouselAdded`);
                request.done(function () {
                  let productDetails = request.responseJSON;
                  let images = productDetails.product.images; // gets all the product images
                  if (!images || images.length < 2) {
                    // If there aren't any secondary images then don't bother making it a carousel
                    return;
                  }

                  let imagesHtml = `<div class="swiper-wrapper">`;
                  for (let i = 0; i < images.length && i < 4; i++) {
                    // Can increase or decrease the number here to get more or less images in the carousel. BEWARE THAT MORE IMAGES = SLOWER LOAD TIMES!
                    let imageUrl = images[i].src;
                    let lastDotIndex = imageUrl.lastIndexOf(".");
                    imageUrl =
                      imageUrl.slice(0, lastDotIndex) + "_x500" + imageUrl.slice(lastDotIndex);
                    imagesHtml += `<div class="swiper-slide"><a href="${pdpLink.href}"><div class="custom-image-styling"><img src="${imageUrl}"/></div></a></div>`; // wrap the images in links so they can click each slide of the carousel
                  }
                  imagesHtml += `</div>`;
                  imagesHtml += `<div class="swiper-button-next"></div>`;
                  imagesHtml += `<div class="swiper-button-prev"></div>`;
                  imagesHtml += `<div class="swiper-pagination"></div>`;
                  imagesHtml += `</div>`;

                  let imageWrapper = productWrap.querySelector(".card__inner"); // get the element currently wrapping the image
                  imageWrapper.classList.add("swiper");
                  imageWrapper.classList.add("redesign-plp-swiper");
                  imageWrapper.innerHTML = imagesHtml;

                  var swiper = new Swiper(".redesign-plp-swiper", {
                    navigation: {
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    },
                    loop: true,
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                  });
                  pdpLink.removeAttribute(`href`);
                });
              });
            }
          }

          // addSlickCarousel();
        } catch (err) {
          console.error(err);
        }
      }

      removeLoader() {
        this.loadingIndicator.remove(this.loadingIndicator);
        this.loadingIndicator = null;
      }
    }
  );
}
